<template>
  <div
      v-show="visible"
      class="modal-container"
      @mousedown="mouseDown"
      @mouseup="mouseUp">
    <component
        :is="modalComponent"
        v-bind="modalProperties"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ModalContainer',
  computed: mapState({
    visible: state => state.modals.component !== null,
    modalComponent: state => state.modals.component,
    modalProperties: state => state.modals.properties,
  }),
  methods: {
    mouseDown(event) {
      if (this.modalProperties && !this.modalProperties.allowDismiss === false) {
        return;
      }

      this.validDismiss = event.target === this.$el;
    },
    mouseUp(event) {
      if (this.modalProperties && this.modalProperties.allowDismiss === false) {
        return;
      }

      if (!this.validDismiss || event.target !== this.$el) {
        return;
      }

      this.$modal.dismiss();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100;
}
</style>
